import { render, staticRenderFns } from "./AddLabourerPaymentItemPage.vue?vue&type=template&id=33f49970&scoped=true&"
import script from "./AddLabourerPaymentItemPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddLabourerPaymentItemPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f49970",
  null
  
)

export default component.exports